// 32ecc37db61fa70464333dd9db4b756d8a985b28|className=IndustryApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=f7339ffb1fa7f8c5bc1f21294c9af9c64e2fc7ec|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseIndustryFromJSON } from '../../../parsers/Industry';

export class IndustryApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags IndustryApi
   * @name IndustryApiGetIndustryList
   * @summary Get all industries
   * @request GET:/industries
   */
  getIndustryList(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/industries`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseIndustryFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function IndustryApi_Factory(t) { return new (t || IndustryApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: IndustryApi, factory: IndustryApi.ɵfac, providedIn: 'root' });
}
